import styled from "styled-components";

/* Page wrapper */
export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  padding: 24px;
  z-index: ${({ isTourActive }) => (isTourActive ? 1002 : 1000)};
  gap: 20px;
`;

/* Card container */
export const Card = styled.div`
  width: 430px;
  max-width: 95vw;
  max-height: 90vh;
  background: #ffffff;
  border-radius: 14px;
  position: relative;
  z-index: 10000;
  pointer-events: auto;
  padding:20px;
  font-family:IBM Plex Sans ;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    opacity: 0.08;
  }

  &::before {
    background: #8b5cf6;
    bottom: -420px;
    left: -200px;
  }

  &::after {
    background: #22d3ee;
    bottom: -460px;
    right: -260px;
  }
`;

/* Typography */
export const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 8px;
  color: #111827;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  text-align: center;
  color: #6b7280;
  margin-bottom: 10px;
`;

export const State = styled.p`
  font-size: 14px;
  text-align: center;
  color: #6b7280;
  margin-bottom: 28px;
`;

/* Fields */
export const Field = styled.div`
  margin-bottom: 18px;
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #111827;
`;

export const Select = styled.div`
  height: 44px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #111827;
  background: ${({ disabled }) => (disabled ? "#f4f4f5" : "#ffffff")};
`;

export const Arrow = styled.span`
  font-size: 14px;
  color: #6b7280;
`;

/* Button */
export const PrimaryButton = styled.button`
  width: 100%;
  height: 48px;
  margin-top: 12px;
  background: #7c3aed;
  border: none;
  border-radius: 999px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  font-family:IBM Plex Sans ;

  &:hover {
    background: #6d28d9;
  }
`;

/* Footer text */
export const Footnote = styled.p`
  margin-top: 14px;
  font-size: 12px;
  text-align: center;
  color: #6b7280;
`;
